import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { VIMEO_API_TOKEN, VIMEO_LIVE_CHAT_TOKEN } from '../constants';
import { VimeoEmbedded } from '../models';

@Injectable()
export class VimeoService {
  constructor(
    private http: HttpClient,
    @Inject(VIMEO_API_TOKEN) private vimeoApiUrl: string,
    @Inject(VIMEO_LIVE_CHAT_TOKEN) private liveChatBaseUrl: string,
  ) {}

  public getoEmbedVideo(url: string): Observable<VimeoEmbedded> {
    return this.http.get<VimeoEmbedded>(
      `${this.vimeoApiUrl}/oembed.json?url=${url}`,
    );
  }

  public getLiveChatUrl(url: string): string {
    return `${this.liveChatBaseUrl}/${parseInt(
      url.replace(/.*\//g, ''),
      10,
    )}/interaction`;
  }
}
